import { render, staticRenderFns } from "./DossierInfoUsers.vue?vue&type=template&id=7c8b1ce3&"
import script from "./DossierInfoUsers.vue?vue&type=script&lang=ts&"
export * from "./DossierInfoUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c8b1ce3')) {
      api.createRecord('7c8b1ce3', component.options)
    } else {
      api.reload('7c8b1ce3', component.options)
    }
    module.hot.accept("./DossierInfoUsers.vue?vue&type=template&id=7c8b1ce3&", function () {
      api.rerender('7c8b1ce3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierInfoUsers.vue"
export default component.exports